import React from 'react';
import { VERSION_LABEL, getVersionDetails } from '../appVersion';

// Discreet, always-visible build version. Fixed to the bottom-right corner so
// it shows on every screen (including login) — hover for commit/env/build time.
const style = {
  position: 'fixed',
  right: 10,
  bottom: 8,
  zIndex: 2000,
  fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
  fontSize: 11,
  lineHeight: 1.4,
  color: '#8794a3',
  background: 'rgba(255, 255, 255, 0.72)',
  border: '1px solid rgba(15, 23, 42, 0.08)',
  padding: '2px 8px',
  borderRadius: 8,
  letterSpacing: '0.02em',
  userSelect: 'none',
  cursor: 'default',
  backdropFilter: 'blur(2px)',
};

function VersionBadge() {
  return (
    <span className="app-version-badge" style={style} title={getVersionDetails()}>
      {VERSION_LABEL}
    </span>
  );
}

export default VersionBadge;
